import React, { useState, useEffect, createContext, useRef, useContext } from "react";
import { format } from "date-fns";
import '../../../css/BillScreen.css';
import { AlertContext, UserContext } from "../../../App";
import maneearabicacoffeetextlogo from '../../../img/logo/maneearabicacoffeetextlogo.png';
import maneeroastersqr from '../../../img/logo/maneeroastersqr.jpeg';
import axios from "axios";
import { API } from "../../../services/api";

axios.defaults.baseURL = API;

function BillScreen() {

    function getDate(gdate) {
        var date = new Date(gdate);
        return format(date, "dd-MM-yyyy HH:mm");
    }

    const {showAlert, setShowAlert, errorMessage, setErrorMessage} = useContext(AlertContext);
    const {userID, LocationID, showForm, setShowForm, setshowSubmenu} = useContext(UserContext);
    const [TemOrderList, setTemOrderList] = useState([]);
    const [subTotal, setSubTotal] = useState(0);
    const [NetTotal, setNetTotal] = useState(0);
    const [Tax, setTax] = useState(0);
    const [PaidAmount, setPaidAmount] = useState(0);
    const [PaidMoreAmount, setPaidMoreAmount] = useState(0);
    const [DiscountAmount, setDiscountAmount] = useState(0);
    const [ChangeAmount, setChangeAmount] = useState(0);

    const [MemberNO, setMemberNO] = useState(0);
    const [PreviousBalance, setPreviousBalance] = useState(0);
    const [NewBalance, setNewBalance] = useState(0);
    const [PreviousPoint, setPreviousPoint] = useState(0);
    const [NewPoint, setNewPoint] = useState(0);
    const [TempCount, setTempCount] = useState(0);
    const [TempTotalCount, setTempTotalCount] = useState(0);


    function currencyFormat(num) {
        if (num !== "") {
            return Number(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        }
    }

    async function getTemOrder () {
        let token = localStorage.getItem("token");
        let qty=0;
        var data = {
            LocationID: LocationID,
        }
        await axios.post("/getTemOrderForBillScreen",data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let tempData = response?.data;
            if(tempData.length > 0){ 
                setTemOrderList(tempData);
            } else {
                setTemOrderList([]);
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    async function getTempTotal () {
        let token = localStorage.getItem("token");
        var data = {
            LocationID: LocationID,
        }
        await axios.post("/getTempTotalForBillScreen",data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let tempData = response?.data;
            if(tempData.length > 0){ 
                setSubTotal(tempData[0].SubTotal);
                setDiscountAmount(tempData[0].Discount);
                setNetTotal(tempData[0].NetTotal);
                setPaidAmount(tempData[0].PaidAmount);
                setChangeAmount(tempData[0].ChangeAmount)
                setMemberNO(tempData[0].MemberNO)
                setPreviousBalance(tempData[0].PreviousBalance)
                setNewBalance(tempData[0].NewBalance)
                setPreviousPoint(tempData[0].PreviousPoint)
                setNewPoint(tempData[0].NewPoint)
            } else {
                setSubTotal(0);
                setDiscountAmount(0);
                setNetTotal(0);
                setPaidAmount(0);
                setChangeAmount(0)
                setMemberNO("")
                setPreviousBalance(0)
                setNewBalance(0)
                setPreviousPoint(0)
                setNewPoint(0)
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    // async function getTemOrder () {
    //     let TemOrderForViewScreen = localStorage.getItem("TemOrderForViewScreen");
    //     setDiscountAmount(localStorage.getItem("DiscountAmount"));
    //     if(localStorage.getItem("PaidAmount") > 0){
    //         setPaidAmount(localStorage.getItem("PaidAmount"));
    //         setChangeAmount(localStorage.getItem("ChangeAmount"));
    //     } else {
    //         setPaidAmount(0);
    //         setChangeAmount(0);
    //     }
        
    //     if (TemOrderForViewScreen) {
    //         let TempOrder = JSON.parse(TemOrderForViewScreen);
    //         setTemOrderList(TempOrder);
    //     } else {
    //         setTemOrderList([]);
    //     }
    // }

    const handleclickBack = () => {
      setShowForm(false);
      setshowSubmenu(true);
    };

    // const getSubtotal = () => {
    //     if (TempOrder) {
    //       if(TempOrder.length > 0){
    //             var gSubTotal = 0;
    //             for (var i=0; i < TempOrder.length; i++) {
    //                 gSubTotal = Number(gSubTotal) + Number(TempOrder[i].SubTotal);
    //             }  
    //             var gNewTax = 0;
    //             var gtax = (Number(gSubTotal) -((Number(gSubTotal) * 100) /110)).toFixed(2);
    //             // var gtax =  gSubTotal * (10 / 100);
    //             // var roundUp = gtax.toString().substr(-3, 3);
    //             // if(roundUp > 500){
    //             //     gNewTax = (Number(gtax) - Number(roundUp)) + 1000;
    //             // } else if(roundUp < 500) {
    //             //     gNewTax = (Number(gtax) - Number(roundUp));
    //             // } else {
    //             //     gNewTax = gtax;
    //             // }
    //             setTax(gtax);
    //             setSubTotal(gSubTotal);
    //             setNewNetTotal(gSubTotal);
    //             setNetTotal(gSubTotal);
    //         } else{
    //             setSubTotal(0);
    //             setNetTotal(0);
    //             setNewNetTotal(0);
    //             setTax(0);
    //         }
    //     } else{
    //         setSubTotal(0);
    //         setNewNetTotal(0);
    //         setNetTotal(0);
    //         setTax(0);
    //     }
    // }

    const getSubtotal = (tempData) => {
        if (tempData) {
          if(tempData.length > 0){
                var gSubTotal = 0;
                var discont = 0;
                var nettatal = 0;
                var paidamount = 0;
                var changeamount = 0;
                var memberNo = 0;
                var previousBalance = 0;
                var newBalance = 0;
                var previousPoint = 0;
                var newPoint = 0;
                for (var i=0; i < tempData.length; i++) {
                    gSubTotal = Number(gSubTotal) + Number(tempData[i].SubTotal);
                    discont = Number(discont) + Number(tempData[i].Discount);
                    nettatal = Number(nettatal) + Number(tempData[i].NetTotal);
                    paidamount = Number(paidamount) + Number(tempData[i].PaidAmount);
                    changeamount = Number(changeamount) + Number(tempData[i].ChangeAmount);
                    if(tempData[i].MemberNO != "")
                    {
                        memberNo = tempData[i].MemberNO;
                        previousBalance = Number(previousBalance) + Number(tempData[i].PreviousBalance);
                        newBalance = Number(newBalance) + Number(tempData[i].NewBalance);
                        previousPoint = Number(previousPoint) + Number(tempData[i].PreviousPoint);
                        newPoint = Number(newPoint) + Number(tempData[i].NewPoint);
                    }
                }  
                setDiscountAmount(discont);
                setSubTotal(gSubTotal);
                setNetTotal(nettatal);
                setPaidAmount(paidamount);
                setChangeAmount(changeamount);
                setMemberNO(memberNo);
                setPreviousBalance(previousBalance);
                setNewBalance(newBalance);
                setPreviousPoint(previousPoint);
                setNewPoint(newPoint);
            } else{
                setSubTotal(0);
                setNetTotal(0);
                setDiscountAmount(0);
                setMemberNO("");
                setPreviousBalance(0);
                setNewBalance(0);
                setPreviousPoint(0);
                setNewPoint(0);
            }
        } else{
            setSubTotal(0);
            setNetTotal(0);
            setDiscountAmount(0);
            setMemberNO("");
            setPreviousBalance(0);
            setNewBalance(0);
            setPreviousPoint(0);
            setNewPoint(0);
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
          getTemOrder();
          getTempTotal();
        }, 300); //set your time here. repeat every 5 seconds
      
        return () => clearInterval(interval);
      }, [TemOrderList]);

    return (
        <div className="BillScreenForm">
            <div className="BillScreenHeader">
                <div className="imglogo">
                   <img src={maneearabicacoffeetextlogo} />
                </div>
                {/* <span>MANEE ARABICA COFFEE</span> */}
                <div className="buttonContent">
              {/* <button className="btn btn-danger" onClick={() => handleclickBack()} >X</button>k00 */}
          </div>
            </div>
                <div className="BillScreenLeftContent">
                    <div className="BillScreenOrderHead">
                        <div className="ProductName">Price / Item</div>
                        <div className="Quantity">Quantity</div>
                        <div className="Price">Total</div>
                    </div>
                    <div className="BillScreenOrderBody">
                        {
                            TemOrderList && TemOrderList.map((x, y) => {
                                return (
                                    <div key={y} className="orderContent">
                                        <div className="orderFooter">
                                            <div className="price">
                                                <p>{currencyFormat(x.Price)}</p>
                                            </div>
                                            <div className="quantity">
                                                <p>{currencyFormat(x.Quantity)}</p>
                                            </div>
                                            <div className="Subtotal">
                                                <p>{currencyFormat(x.Total)}</p>
                                            </div>
                                        </div>
                                        <div className="orderBody">
                                            <div className="detail">
                                                <div className="productName">
                                                    <span>{y+1}. {x.EngName} Sugar: {x.Sugar} %</span>         
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                <div className="BillScreenRightContent">
                    <div className="BillScreenRightContentBody">
                    <div className="subtotal">
                        <span>Subtotal:</span>
                        <strong>{currencyFormat(subTotal)}</strong>
                    </div>
                    <div className="discout">
                        <span>Discount:</span>
                        <strong>{currencyFormat(DiscountAmount) || '0'}</strong>
                    </div>
                    <div className="nettotal">
                        <span>NetTotal:</span>
                        <strong>{currencyFormat(NetTotal) || '0'}</strong>
                    </div>
                    <div className="billScreenfooter-line"></div>
                    <div className="paidAmount">
                        <span>PaidAmount:</span>
                        <strong>{currencyFormat(PaidAmount) || '0'}</strong>
                    </div>
                    <div className="changeAmount">
                        <span>ChangeAmount:</span>
                        <strong>{currencyFormat(ChangeAmount) || '0'}</strong>
                    </div>
                    
                    { MemberNO && 
                        <div className="MemerCard">
                            <div className="billScreenfooter-line"></div>
                            <div className="paidAmount">
                                <label>Member NO:</label>
                                <span>{MemberNO}</span>
                            </div>
                            <div className="paidAmount">
                                <label>Balance</label>
                                <span>{currencyFormat(PaidAmount)}</span>
                            </div>
                            <div className="paidAmount">
                                <label>New Balance:</label>
                                <span>{currencyFormat(ChangeAmount)}</span>
                            </div>
                             <div className="paidAmount">
                                <label>Point:</label>
                                <span>{currencyFormat(PreviousPoint)}</span>
                            </div>
                             <div className="paidAmount">
                                <label>New Point:</label>
                                <span>{currencyFormat(NewPoint)}</span>
                            </div>
                        </div>
                    }
                    { !MemberNO &&<div className="QRImage">
                        <img src={maneeroastersqr} />
                        </div>
                    }
                </div>
            </div>
        </div >
    );
};

export default BillScreen;
